import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router'
import { HttpClient } from '@angular/common/http';
import { BigNumber } from "ethers";
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { UserService } from 'app/services/user/user.service';
import { Web3Service } from 'app/services/web3/web3.service';
import { ContractsService } from 'app/services/contract/contracts.service';
import { eContracts } from 'app/services/contract/contract.config';
import { SimpleStorageService } from 'app/services/storage/simple-storage.service';
import { environment } from 'environments/environment';

declare const Simplex;
declare const analytics;
@Component({
  selector: 'app-first-lootbox',
  templateUrl: './first-lootbox.component.html',
  styleUrls: ['./first-lootbox.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FirstLootboxComponent implements OnInit {

  // public account
  public foundKryptomon
  public lootBoxes: any = []
  public isLoading
  public successTx
  public boxSelected: any = [false, false, false, false]
  public selectedBox: any = { missing: false }
  public hasAllowance
  public kmonBalance
  public parsedBoxes
  public showWidget
  public kmonBalanceInit
  public bnbBalanceInit
  public simulateSuccess
  public waitingForFunds
  public fundsArrived
  public purchaseCompleted
  public unfreeze: any = {}
  public unfreezeSelected
  wallet: string;
  web3: any;

  constructor(
    private simpleStorageService: SimpleStorageService,
    private router: Router,
    private http: HttpClient,
    private toastService: ToastService,
    private userService: UserService,
    private web3Service: Web3Service,
    private contractsService: ContractsService
  ) {

    this.isLoading = false;
    this.successTx = false;
    this.parsedBoxes = false;
    this.showWidget = false;
    this.simulateSuccess = false;
    this.waitingForFunds = false;
    this.fundsArrived = false;
    this.purchaseCompleted = false;
    this.unfreezeSelected = false;

    // if (this.appComponent.accounts == undefined) {
    //   this.appComponent.accountsObservable.subscribe((item: any) => {
    //     this.wallet = item[0];
    //     this.getKmonBalance();
    //     this.getBnbBalance();
    //   });
    // } else {
    //   this.wallet = this.appComponent.accounts[0];
    //   this.getKmonBalance();
    //   this.getBnbBalance();
    // }
    this.wallet = this.userService._userInfoData.recordedWallet;
    this.web3 = this.web3Service.getWeb3();
    this.getKmonBalance();
    this.getBnbBalance();

    console.log(this.simpleStorageService.getSimple('foundKryptomon'))
    if (this.simpleStorageService.getSimple('foundKryptomon') !== undefined) {
      this.foundKryptomon = this.simpleStorageService.getSimple('foundKryptomon');
      if (this.foundKryptomon.nft.isFreezed == 1) {
        this.selectUnfreeze();
      }
    } else {
      this.router.navigate(['/onboarding/find'])
    }
  }


  ngOnInit(): void {
  }

  async getLootboxes() {
    this.lootBoxes = []
    await this.contractsService.getContract(eContracts.Lootbox).methods.getItems().call().then((item) => {
      console.log(this.kmonBalance)
      for (let i = 0; i < item.length; i++) {

        let lootBox: any = {}

        if (item[i].name == "0x4c4f4f54424f585f424153494300000000000000000000000000000000000000") {

          lootBox.formattedName = "Bronze Box"
          lootBox.chainName = item[i].name;
          lootBox.chainPrice = item[i].price
          lootBox.type = "basic"
          lootBox.formattedPriceUSD = 1.49
          lootBox.formattedPriceKMON = (Math.round(parseFloat(this.web3.utils.fromWei(item[i].price.toString())) * 100) / 100).toLocaleString()
          lootBox.img = "./assets/img/Icon/lootbox-bronze.png"
          lootBox.priceKMON = (Math.round(parseFloat(this.web3.utils.fromWei(item[i].price.toString())) * 100) / 100)
          lootBox.description = "The bare minimum collection of items, with these box you'll be capable to keep your friend fed, but I wouldn't bet on his happiness, you will receive these boxes for free every day!"
          if (parseFloat(lootBox.priceKMON) > this.kmonBalance) {
            lootBox.missing = true;
          }
          this.lootBoxes.push(lootBox);

        } else if (item[i].name == "0x4c4f4f54424f585f4d454449554d000000000000000000000000000000000000") {

          lootBox.formattedName = "Silver Box"
          lootBox.chainName = item[i].name;
          lootBox.chainPrice = item[i].price
          lootBox.type = "medium"
          lootBox.formattedPriceUSD = 9.99
          lootBox.formattedPriceKMON = (Math.round(parseFloat(this.web3.utils.fromWei(item[i].price.toString())) * 100) / 100).toLocaleString()
          lootBox.img = "./assets/img/Icon/lootbox-silver.png"
          lootBox.priceKMON = (Math.round(parseFloat(this.web3.utils.fromWei(item[i].price.toString())) * 100) / 100)
          lootBox.description = "The good compromise, with the Silver Box you get enough items to keep your friend fed and happy for some days!"
          if (parseFloat(lootBox.priceKMON) > this.kmonBalance) {
            lootBox.missing = true;
          }
          this.lootBoxes.push(lootBox);

        } else if (item[i].name == "0x4c4f4f54424f585f5052454d49554d0000000000000000000000000000000000") {

          lootBox.formattedName = "Gold Box"
          lootBox.chainName = item[i].name;
          lootBox.chainPrice = item[i].price
          lootBox.type = "premium"
          lootBox.formattedPriceUSD = 19.99
          lootBox.formattedPriceKMON = (Math.round(parseFloat(this.web3.utils.fromWei(item[i].price.toString())) * 100) / 100).toLocaleString()
          lootBox.img = "./assets/img/Icon/lootbox-gold.png"
          lootBox.priceKMON = (Math.round(parseFloat(this.web3.utils.fromWei(item[i].price.toString())) * 100) / 100)
          lootBox.description = "Only the best of the best for your friend, with this box you'll be able to keep your Kryptomon healthy, fed and happy and also get some extra boost in training."
          if (parseFloat(lootBox.priceKMON) > this.kmonBalance) {
            lootBox.missing = true;
          }
          this.lootBoxes.push(lootBox);

        } else if (item[i].name == "0x554e465245455a455f504f54494f4e0000000000000000000000000000000000") {
          this.unfreeze.formattedName = "Unfreezing Potion"
          this.unfreeze.chainName = item[i].name;
          this.unfreeze.chainPrice = item[i].price
          this.unfreeze.type = "premium"
          this.unfreeze.formattedPriceUSD = 0.99
          this.unfreeze.formattedPriceKMON = (Math.round(parseFloat(this.web3.utils.fromWei(item[i].price.toString())) * 100) / 100).toLocaleString()
          this.unfreeze.img = "./assets/img/Icon/unfreeze-potion.png"
          this.unfreeze.priceKMON = (Math.round(parseFloat(this.web3.utils.fromWei(item[i].price.toString())) * 100) / 100)
          this.unfreeze.description = "This special potion comes always useful, when your Kryptomon freeze due to a lack of caring, then give them this potion to revitilize them."
        }

      }
      this.parsedBoxes = true;
      console.log(this.parsedBoxes)
      this.selectBox(0)
    })
  }

  selectBox(index) {
    analytics.track('clicked button', { section: 'onboarding', value: "lootbox", step: 'step 2' });
    for (let i = 0; i < 3; i++) {
      if (i == index && !this.boxSelected[i] && i > 0) {
        this.boxSelected[i] = true;
        this.selectedBox = this.lootBoxes[i]
        analytics.track('selected extra item', { section: 'onboarding', value: this.selectedBox.formattedName, step: 'step 2' });
      } else {
        this.boxSelected[i] = false;

      }
    }

    if (!this.boxSelected[1] && !this.boxSelected[2]) {
      analytics.track('unselected extra item', { section: 'onboarding', value: this.selectedBox.formattedName, step: 'step 2' });
      this.selectedBox = undefined
    }
    console.log(this.selectedBox)
  }

  async startPurchase() {
    let boxId = this.selectedBox.chainName;
    let boxType = this.selectedBox.type
    let amount = "1";
    console.log(amount)
    await this.contractsService.getContract(eContracts.Lootbox).methods.buyItem(this.wallet, boxId, amount).send({
      ...this.contractsService.additionalParameters(),
      from: this.wallet
    }).then((item) => {
      console.log(item)
      if (item.status) {
        this.isLoading = false;
        this.successTx = true;
      }
    })
  }

  async checkAllowance() {
    console.log(this.wallet)
    this.isLoading = true;
    let allowance = await this.contractsService.getContract(eContracts.KMON).methods.allowance(this.wallet, "0xbf2E98268c8A90eE943c6Ef8E7340F0052F26b0d").call();
    this.hasAllowance = BigNumber.from(allowance).gt(0);
    console.log(this.hasAllowance)
    if (this.hasAllowance) {
      this.startPurchase()
    } else {
      this.contractsService.getContract(eContracts.KMON).methods.approve("0xbf2E98268c8A90eE943c6Ef8E7340F0052F26b0d", this.web3.utils.toWei('999999999999')).send({
        ...this.contractsService.additionalParameters(),
        from: this.wallet
      }).then((result) => {
        console.log(result)
        if (result.events.Approval !== undefined) {
          this.startPurchase()
        }
      }).catch((err) => {
        this.isLoading = false;
        console.log('allowance failed')
        this.toastService.genericError();
      });;
    }
  }

  lastComplete() {
    let steps = this.simpleStorageService.getSimple('steps');
    steps[3] = true;
    this.simpleStorageService.setSimple('steps', steps);
    this.router.navigate(["/onboarding/complete"])
  }

  async getKmonBalance() {
    const balance = await this.contractsService.getContract(eContracts.KMON).methods.balanceOf(this.wallet).call();
    this.kmonBalance = await parseFloat(this.web3.utils.fromWei(balance))
    this.kmonBalanceInit = await parseFloat(this.web3.utils.fromWei(balance))
    this.getLootboxes()
  }

  async getBnbBalance() {
    const balanceBnb = await this.web3.eth.getBalance(this.wallet);
    this.bnbBalanceInit = await parseFloat(this.web3.utils.fromWei(balanceBnb))
  }

  gotoBalanceFill() {
    //this.router.navigate(["/onboarding/balancefill"])
  }

  startPurchaseSimplex() {
    this.isLoading = true;
    let post = { walletId: this.wallet, amount: 30 }
    console.log(post)
    this.http.post(environment.apiBaseUrl + "simplex/makePurchase.php", post).subscribe((item: any) => {
      console.log(item)
      this.isLoading = false;
      if (item.status == "done") {
        this.showWidget = true;
        const params = {
          payment_id: item.payload.paymentId
        }

        Simplex.load(params, (event) => {

          Simplex.subscribe('onlineFlowFinished', (event) => {
            if (event.payload.result == "success") {
              this.checkBnbPurchase()
              setTimeout(() => {
                this.simulateSuccess = true
              }, 10000)
            } else {
              this.toastService.genericError();
              console.log('ops something went wrong')
            }
          })
        })
      } else {
        this.toastService.genericError();
      }
    })
  }

  closeSimplex() {
    Simplex.unload();
    this.showWidget = false;
    this.waitingForFunds = false;
    this.purchaseCompleted = false;
    this.fundsArrived = false;
  }

  async checkBnbPurchase() {

    Simplex.unload();
    this.waitingForFunds = true;
    const balanceBnb = await this.web3.eth.getBalance(this.wallet);
    let newBnbBalance = await parseFloat(this.web3.utils.fromWei(balanceBnb))
    if (newBnbBalance > this.bnbBalanceInit || this.simulateSuccess) {
      let bnbReceived = newBnbBalance - this.bnbBalanceInit;
      this.fundsArrived = true;
      this.checkAllowanceSimplex()
    } else {
      setTimeout(() => {
        this.checkBnbPurchase();
      }, 5000)
    }

  }

  async convertBNBtoKMON(bnbAmount = 0.0001) {
    this.http.get("https://api.pancakeswap.info/api/v2/tokens/0xc732B6586A93b6B7CF5FeD3470808Bc74998224D").subscribe((item: any) => {
      let minKmonAmount = bnbAmount / item.data.price_BNB * 0.80;
      let bnbAmountWei = this.web3.utils.toWei(bnbAmount.toString());
      let minKmonAmountWei = this.web3.utils.toWei(minKmonAmount.toString());
      let path = ["0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", "0xc732B6586A93b6B7CF5FeD3470808Bc74998224D"]
      let expiry = Math.floor(Date.now() / 1000) + 60 * 10;
      let expireWei = this.web3.utils.toWei(expiry.toString());
      console.log(expireWei)
      this.contractsService.getContract(eContracts.PancakeV2).methods.swapExactETHForTokens(minKmonAmountWei, path, this.wallet, expireWei).send({
        ...this.contractsService.additionalParameters(),
        from: this.wallet,
        value: bnbAmountWei
      }).then((item) => {
        if (item.status) {
          this.purchaseCompleted = true;
          this.getKmonBalance();
        } else {
          this.toastService.genericError();
        }
      })
    }, (err) => {
      this.toastService.genericError();
    })

  }

  async checkAllowanceSimplex() {
    let allowance = await this.contractsService.getContract(eContracts.WBNB).methods.allowance(this.wallet, "0x10ED43C718714eb63d5aA57B78B54704E256024E").call();
    this.hasAllowance = BigNumber.from(allowance).gt(0);
    console.log(this.hasAllowance)
    if (this.hasAllowance) {
      this.convertBNBtoKMON()
    } else {
      this.contractsService.getContract(eContracts.WBNB).methods.approve("0x10ED43C718714eb63d5aA57B78B54704E256024E", this.web3.utils.toWei('999999999999')).send({
        ...this.contractsService.additionalParameters(),
        from: this.wallet
      }).then((result) => {
        console.log(result)
        if (result.events.Approval !== undefined) {
          this.convertBNBtoKMON()
        } else {
          this.toastService.genericError();
        }
      }).catch((err) => {
        console.log('allowance failed')
        this.toastService.genericError();
      });;
    }
  }

  selectUnfreeze() {
    this.unfreezeSelected = !this.unfreezeSelected
    if (this.unfreezeSelected) {
      analytics.track('selcted extra item', { section: 'onboarding', value: 'unfreeze-potion', step: 'step 2' });
    } else {
      analytics.track('unselected extra item', { section: 'onboarding', value: 'unfreeze-potion', step: 'step 2' });
    }
  }

  confirmBox() {
    this.simpleStorageService.setSimple('selectedBox', this.selectedBox);
    if (this.unfreezeSelected) {
      this.simpleStorageService.setSimple('unfreezeSelected', this.unfreeze);
    } else {
      this.simpleStorageService.setSimple('unfreezeSelected', false);
    }
    analytics.track('clicked button', { section: 'onboarding', value: "next", step: 'step 2' });
    this.router.navigate(['/onboarding/balancefill'])
  }

  goBack() {
    analytics.track('clicked button', { section: 'onboarding', value: "back", step: 'step2' });
    this.router.navigate(['/onboarding/find'])
  }

}
